import { get, post } from './base'

const userApi = {
  // 修改密码
  changePassword({ newPassword, oldPassword }) {
    return post('api/user/change_password', { newPassword, oldPassword })
  },

  // 获取用户信息
  getUserDetails() {
    return get('api/user/details')
  },

  // 获取用户信息 v2
  getUserDetailsV2() {
    return get('api/user/detailsV2')
  },

  // 更新用户信息
  updateUserProfile(userInfo) {
    return post('api/user/update_profile', userInfo)
  },

  // 获取用户拥有的号码列表
  getUserPhones() {
    return get('api/user/phones')
  },

  // 获取用户曾经拥有的历史号码列表
  getUserHistoryPhones() {
    return get('api/phoneNum/getHistoryFaxNumber')
  },

  // 设置默认号码
  setDefaultPhone(currentFaxNum) {
    return post('api/phoneNum/defaultPhone', { currentFaxNum })
  },

  // 获取用户邀请码
  generateInviteCode() {
    return post('api/generateInviteCode')
  },

  // 获取用户当前积分
  getCredit(type) {
    // 0 充值
    // 1 邀请
    const params = Object.create(null)
    if (type !== undefined) {
      params.type = type
    }
    return get('/api/credit', params)
  },

  // 购买积分
  buyCredit({ creditValue, currency }) {
    return post('api/buy_credit', {
      creditValue,
      currency,
    })
  },

  // 通过 商品 ID 购买积分
  buyCreditById(creditsId) {
    return post('api/buyCredits', {
      creditsId,
    })
  },

  // 发送验证码到邮箱
  sendVerifyCode(email) {
    return post('api/user/sendVerifyCode', { email, type: '' })
  },

  // 验证邮箱
  verifyEmail(email, verifyCode) {
    return post('api/user/verifyEmail', { email, verifyCode })
  },

  // 获取分配号码
  getFreeNumber() {
    return get('api/user/get_freenumber')
  },

  // 设置默认coverid
  setDefaultFaxCover(coverId) {
    return post('api/user/setDefaultFaxCover', { coverId })
  },

  //google drive 绑定
  setGDriveBind(code) {
    return post('api/google/driver/grant', code)
  },
  //取消 google drive 绑定
  closeGDriveBind() {
    return post('api/google/driver/cancelGrant', {})
  },

  // Slack绑定开关
  setSlackBind(code) {
    return post('api/slack/auth', code)
  },

  // 取消Slack绑定
  closeSlackBind() {
    return post('api/slack/delete', {})
  },

  // 获取Slack Channel
  getSlackChannel() {
    return get('api/slack/channel', {}, { noMsg: true })
  },

  // 设置Slack Channel
  setNotifyChannel(slackInfo) {
    return post('api/slack/set_notify_channel', slackInfo)
  },

  //获取用户已设置的slack信息
  getNotifyChannel() {
    return post('api/notification/switch', {})
  },

  //slack test
  slactTest() {
    return post('/api/slack/test', {})
  },
  //获取邮件设置
  getEmailSet() {
    return get('api/emailNotificationConfig/find')
  },
  //邮件通知设置
  SetEmailNotice({ type, reciveType, enableMutilAddress, emailAddress }) {
    return post('api/emailNotificationConfig/update', {
      type,
      reciveType,
      enableMutilAddress,
      emailAddress,
    })
  },
  //获取SMS短信设置
  getSmsSet() {
    return get('api/smsNotificationConfig/find')
  },
  //发送短信验证码
  sendSmsVerifyCode(smsPhone) {
    return post('api/smsNotificationConfig/sendSmsVerifyCode', {
      smsPhone,
    })
  },
  //验证 验证码
  verifySmsPhone(verifyCode) {
    return post('api/smsNotificationConfig/verifySmsPhone', {
      verifyCode,
    })
  },
  // 更新收发传真短信通知开关
  smsUpdate({ sendFaxSwitch, receiveFaxSwitch }) {
    return post('api/smsNotificationConfig/update', {
      sendFaxSwitch,
      receiveFaxSwitch,
    })
  },
}

export default userApi
